// 4th argument: globalLevel (required for A2 logic)
// Usage: limitWordsAndSpaces(prevValue, maxWords, newValue, globalLevel)
export function limitWordsAndSpaces(text, maxWords, newtext, globalLevel) {

  if (globalLevel === 'A2') {
    const prevWords = text.trim().split(/\s+/).filter(Boolean);
    const newWords = newtext.trim().split(/\s+/).filter(Boolean);
    const prevLength = text.length;
    const newLength = newtext.length;

    if (newWords.length < maxWords) {
      return newtext;
    }

    if (newWords.length > maxWords) {
      // If the change is a paste (difference is more than 1 word), allow truncation
      if (newWords.length - prevWords.length > 1) {
        return newWords.slice(0, maxWords).join(' ');
      }
      // Otherwise, block as before
      return text;
    }

    if (newWords.length === maxWords) {
      if (newLength < prevLength) {
        return newtext;
      }
      //Block ANY added space
      if (newLength > prevLength) {
        for (let i = 0; i < newLength; i++) {
          if (text[i] !== newtext[i]) {
            if (newtext[i] === ' ') {
              return text;
            }
            break;
          }
        }
        //block trailing space explicitly
        if (newtext.endsWith(' ') && !text.endsWith(' ')) {
          return text;
        }
      }
      return newtext;
    }
    return text;
  } else {
    let wordCount = 0;
    let lastIndex = 0;
    text.replace(/\S+/g, (match, index) => {
      wordCount++;
      if (wordCount === maxWords) {
        lastIndex = index + match.length;
      }
    });

    if (wordCount < maxWords) {
      return text;
    }

    // Slice up to the last word and remove any trailing spaces
    return text.slice(0, lastIndex);
  }
}